(function () {
    'use strict';

    var module = angular.module('uwAgenda.global');
    module.controller('SidebarController', [
        '$rootScope', 
        '$scope', 
        '$uibModal', 
        '$state', 
        '$localStorage', 
        'SharedAgendaService', 
        'UserService', 
        'SharedAgendaBroadcast', 
        'UserWebsiteService', 
        'AppConfig',
        SidebarControllerFn
    ]);

    /* Sidebar Controller */
    function SidebarControllerFn(
        $rootScope, 
        $scope, 
        $uibModal, 
        $state, 
        $localStorage, 
        SharedAgendaService, 
        UserService, 
        SharedAgendaBroadcast, 
        UserWebsiteService,
        AppConfig) {
        var vm = this;

        // variables
        vm.isYearOverviewOpen = false;
        vm.currentUserId = 0;
        vm.isRingfoonAdmin = false;
        vm.isRingfoonOperatorAdmin = false;
        vm.isRingfoonOperator = false;
        vm.isRingfoon = false;
        vm.isSubuserAdmin = false;
        vm.isSubuser = false;
        vm.isColleague = false;
        vm.isMainuser = false;
        vm.showAgendaDropdown = false;
        // online-booking-links
        vm.singleOnlineBookingLink = null;
        vm.groupOnlineBookingLink = null;
        // Wordpress Links
        vm.websiteLink = null;
        vm.adminPanelLink = null;
        vm.settingsPanelLink = null;
        // Popular downloads
        vm.purl = null;
        vm.clearActiveSettingsTab = clearActiveSettingsTab;

        vm.enableViews = AppConfig.FT_EnableViews === true ||
                         AppConfig.FT_EnableViews === 'true';

        // listen on changed selected client
        var agendaChangedListener = $scope.$on(SharedAgendaBroadcast.AgendaChanged, function () {
            agendaOwnerChanged();
        });

        var agendaOwnerChangedListener = $scope.$on(SharedAgendaBroadcast.AgendaOwnerChanged, function () {
            agendaOwnerChanged();
        });

        activate();

        function clearActiveSettingsTab (){
            $localStorage.activeSettingsTab = "" ;
        }

        // agenda change
        function agendaOwnerChanged() {
            let currentUser = SharedAgendaService.currentUser();
            vm.currentUserId = currentUser.id;
            
            vm.currentUserIsRingphoneAdmin = SharedAgendaService.currentUserIsRingphoneAdmin();

            var prefix = 'http://';

            // get online-booking-links (only for ringfoon)
            if ($rootScope.isRingfoonAdmin || $rootScope.isMainuser || $rootScope.isSubuserAdmin) {
                // online-booking links
                UserService.singleOnlineBookingLink(vm.currentUserId, SharedAgendaService.data.currentAgenda.id).then(function (result) {
                    vm.singleOnlineBookingLink = result.url;
                });
                UserService.groupOnlineBookingLink(vm.currentUserId, SharedAgendaService.data.currentAgenda.id).then(function (result) {
                    vm.groupOnlineBookingLink = result.url;
                });

                vm.adminPanelLink = null;
                vm.settingsPanelLink = null;
                vm.websiteLink = null;

                if (currentUser.websiteId) {
                    if ($rootScope.isRingfoonAdmin) {
                        UserWebsiteService.wp(currentUser.websiteId, true).then(function (result) {
                            // set link
                            vm.adminPanelLink = result && result.length ? prefix + result[0] : undefined;
                        });
                    } // if
                    UserWebsiteService.wp(currentUser.websiteId, false).then(function (result) {
                        // set link
                        vm.settingsPanelLink = result && result.length ? prefix + result[0] : undefined;
                    });
                    UserWebsiteService.wp(currentUser.websiteId).then(function (result) {
                        // set link
                        vm.websiteLink = result && result.length ? prefix + result[0] : undefined;
                    });
                } // if

            } // if

            // make url for popular downloads -> translation depending
            vm.purl = 'http://download_' + $localStorage.CurrentLanguage.shortCut + '.ringphone.com';

        } // agendaChanged


        /* show Year-View */
        vm.showYearOverviewCalendar = function () {
            // open modal
            var modalInstance = $uibModal.open({
                backdrop: true,
                keyboard: true,
                animation: true,
                templateUrl: '/app/global/templates/rf-global-calendar-yearoverview.template.html',
                controller: 'CalendarYearoverviewController',
                controllerAs: 'vm',
                size: 'xl'

            });

            // when modal is closed
            modalInstance.result.then(function (task) {
            }, function () {
                //dismissed
            });
        };

        /* activation work */
        function activate() {
            // Metronic INIT
            Layout.initSidebar($state);

            // set currentUserId in scope to use it for ui-sref paramaters
            vm.currentUserId = SharedAgendaService.data.currentAgenda.owner.id;

            let currentUser = SharedAgendaService.currentUser();

            // set user-roles
            
            // these are the user roles of the currently viewing user
            vm.currentUserIsRingphoneAdmin = SharedAgendaService.currentUserIsRingphoneAdmin();
            
            // these are the user roles of the logged in user
            vm.isRingfoonAdmin = $rootScope.isRingfoonAdmin;
            vm.isRingfoonOperatorAdmin = $rootScope.isRingfoonOperatorAdmin;
            vm.isRingfoonOperator = $rootScope.isRingfoonOperator;
            vm.isRingfoon = $rootScope.isRingfoon;
            vm.isSubuserAdmin = $rootScope.isSubuserAdmin;
            vm.isSubuser = $rootScope.isSubuser;
            vm.isColleague = $rootScope.isColleague;
            vm.isMainuser = $rootScope.isMainuser;

            // no need to display shared agenda toolbar, 
            // if user has only access to his own agenda

            if ((vm.isMainuser || vm.isSubuserAdmin) &&
                SharedAgendaService.data.agendas.length > 1) {
                vm.showAgendaDropdown = true;
            }            
        
            agendaOwnerChanged();
        }

        $scope.$on("$destroy", function () {
            if (agendaChangedListener) {
                agendaChangedListener();
                agendaChangedListener = null;
            }

            if (agendaOwnerChangedListener) {
                agendaOwnerChangedListener();
                agendaOwnerChangedListener = null;
            }
        });
    }
})();
